import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withHookForMeme, withUpdateMeme } from "src/modules/meme/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateMeme } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await updateMeme(values);
        router.push("/meme");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForMeme, withUpdateMeme)(Edit);
